"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dark_theme_1 = __importDefault(require("../../global/dark-theme"));
var use_media_query_hook_1 = __importDefault(require("../../hooks/use-media-query.hook"));
var ShowOrHideState;
(function (ShowOrHideState) {
    ShowOrHideState["SHOW"] = "show";
    ShowOrHideState["HIDE"] = "hide";
})(ShowOrHideState = exports.ShowOrHideState || (exports.ShowOrHideState = {}));
var getCurrentMediaQuery = {
    showOnSmallAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.sm,
        display: ShowOrHideState.SHOW,
    },
    showOnMediumAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.md,
        display: ShowOrHideState.SHOW,
    },
    showOnLargeAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.lg,
        display: ShowOrHideState.SHOW,
    },
    showOnXLargeAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.xl,
        display: ShowOrHideState.SHOW,
    },
    showOnXXLargeAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.xxl,
        display: ShowOrHideState.SHOW,
    },
    hideOnSmallAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.sm,
        display: ShowOrHideState.HIDE,
    },
    hideOnMediumAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.md,
        display: ShowOrHideState.HIDE,
    },
    hideOnLargeAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.lg,
        display: ShowOrHideState.HIDE,
    },
    hideOnXLargeAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.xl,
        display: ShowOrHideState.HIDE,
    },
    hideOnXXLargeAndUp: {
        breakpointValue: dark_theme_1.default.breakpoints.xxl,
        display: ShowOrHideState.HIDE,
    },
};
var Visibility = function (_a) {
    var children = _a.children, breakpoint = _a.breakpoint;
    var currentMediaQueryObject = getCurrentMediaQuery[breakpoint];
    var mediaQuery = use_media_query_hook_1.default(currentMediaQueryObject.breakpointValue);
    return (react_1.default.createElement(react_1.default.Fragment, null, currentMediaQueryObject.display === ShowOrHideState.SHOW ? mediaQuery && children : !mediaQuery && children));
};
exports.default = Visibility;
//# sourceMappingURL=visibility.component.js.map